import axios from 'axios';
import b64toblob from 'b64-to-blob';

type S3UploadImageData = {
  image: string;
  uploadUrl: string;
  contentType: string;
};

const instance = axios.create();
delete instance.defaults.headers.common.Authorization;

export const uploadImageToS3 = async (requestData: S3UploadImageData) => {
  const { image, uploadUrl, contentType } = requestData;

  let correctImage = image.split(',')[1];
  if (!correctImage) {
    correctImage = image;
  }

  // TODO: No need to use a library, fetch() API can be used instead.
  const blobImage = b64toblob(correctImage, contentType);

  try {
    const response = await instance.put(uploadUrl, blobImage, { headers: { 'Content-Type': contentType } });
    return response;
  } catch (error) {
    return { success: false };
  }
};
